<script>
    import Content from '/srv/web/wyvr/html/releases/58819/gen/client/shop/messages/Content.svelte?1733898724801';

    export let message;
</script>

<div><Content message={message} type={'m-message--info'} /></div>